import axios from "axios";

export const getData = ({ uen }) => {
  const fields = ["*"];

  const requestUrl = `/data/financials/${uen}`;

  let params = {
    fields: fields.join(",")
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getAssociationDashboard = ({ uen, clients }) => {
  const requestUrl = `/data/financial/association`;

  let params = {
    uen,
    clients
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getOrganizations = data => {
  let {
    pageSize,
    paginationPage,
    name,
    type,
    juridicalForms,
    collaborators,
    roleCollaborator,
    clientCRMTypes,
    clientCRMGroup,
    sortMetrics,
    configState,
    year,
    presentationState,
    synchroState,
    uid,
    currentOrganization,
    spaceAs,
    synchro,
    importedBalance
  } = data;
  const fields = [];
  const requestUrl = `/data/financials`;
  let filter = [];
  let customFilter = {};

  if (name && name.length > 0) {
    filter.push({
      property: "name",
      value: name,
      operator: "like"
    });
  }
  if (type && type.length > 0) {
    filter.push({
      property: "societyType",
      value: type,
      operator: "in"
    });
  }
  if (importedBalance && importedBalance.length > 0) {
    filter.push({
      property: "id",
      value: importedBalance,
      operator: "in"
    });
  }

  if (configState && configState.length > 0) {
    customFilter.configState = configState;
  }

  if (year) {
    customFilter.year = year;
  }

  if (presentationState && presentationState.length > 0) {
    customFilter.presentationState = presentationState;
  }

  if (juridicalForms && juridicalForms.length > 0) {
    filter.push({
      property: "juridicalForm",
      value: juridicalForms.map(({ value }) => value),
      operator: "in"
    });
  }
  if (clientCRMTypes && clientCRMTypes.length > 0) {
    filter.push({
      property: "type",
      value: clientCRMTypes,
      operator: "in"
    });
  }

  if (clientCRMGroup && clientCRMGroup.length > 0) {
    filter.push({
      property: "groupDescription",
      value: clientCRMGroup,
      operator: "in"
    });
  }

  let sort = [];

  if (sortMetrics && sortMetrics.length > 0) {
    sort.push(JSON.parse(sortMetrics));
  }

  sort.push({
    property: "updatedAt",
    dir: "desc"
  });
  let params = {
    fields: fields.join(","),
    uid: uid,
    organization: currentOrganization && currentOrganization.uen,
    collaborators:
      synchro && spaceAs === "MANAGER"
        ? collaborators.map(({ value }) => value)
        : [],
    roleCollaborator: roleCollaborator,
    loggedAs: spaceAs,
    synchro: synchro,
    synchroState: synchroState,
    customFilter: JSON.stringify(customFilter),
    limit: pageSize || 10,
    start: !paginationPage ? 0 : (paginationPage - 1) * pageSize
  };

  params.filter = JSON.stringify(filter).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};

export const getJuridicalForms = ({ lng = "fr", searchWord = null }) => {
  const requestUrl = `/data/references/juridical_form`;
  const fields = ["*"];
  let filter = [];

  if (null !== searchWord) {
    filter = [
      {
        property: "label" + lng.charAt(0).toUpperCase() + lng.slice(1),
        value: searchWord,
        operator: "like"
      }
    ];
  }
  return axios.get(requestUrl, {
    params: {
      fields: fields.join(","),
      filter: JSON.stringify(filter)
    }
  });
};

export const associateDashboard = ({ dashboardId, selected }) => {
  const requestUrl = `/data/financial/associate`;

  var formData = new FormData();

  formData.append("dashboard", dashboardId);
  formData.append("clients", selected);

  return axios.post(requestUrl, formData);
};

export const getFinancialFiche = (organizationUen, year) => {
  const requestUrl = `/data/financial/fiche`;

  let params = {
    organizationUen: organizationUen,
    year: year
  };
  return axios.get(requestUrl, { params });
};

export const requestSynchro = ({ organizationUen, status }) => {
  const requestUrl = `/data/financial/fiche/sync-request`;

  var formData = new FormData();

  formData.append("organizationUen", organizationUen);
  formData.append("syncRequestStatus", status);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/data.js